/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { PartialDataBlockFromJSON, PartialDataBlockToJSON } from './';
export function PartialDataMappingFromJSON(json) {
    return PartialDataMappingFromJSONTyped(json, false);
}
export function PartialDataMappingFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        rowTagIds: !exists(json, 'rowTagIds') ? undefined : json['rowTagIds'],
        columnTagIds: !exists(json, 'columnTagIds') ? undefined : json['columnTagIds'],
        dataBlocks: json['dataBlocks'].map(PartialDataBlockFromJSON),
    };
}
export function PartialDataMappingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        rowTagIds: value.rowTagIds,
        columnTagIds: value.columnTagIds,
        dataBlocks: value.dataBlocks.map(PartialDataBlockToJSON),
    };
}
